import { render, staticRenderFns } from "./ModifsProvisoires.vue?vue&type=template&id=70096599&scoped=true"
import script from "./ModifsProvisoires.vue?vue&type=script&lang=js"
export * from "./ModifsProvisoires.vue?vue&type=script&lang=js"
import style0 from "./ModifsProvisoires.vue?vue&type=style&index=0&id=70096599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70096599",
  null
  
)

export default component.exports